/** Administrateur : paramètres organisation + équipe + heures & majoration */
export const ROLE_BIG_COMPANY_ADMIN = 225;

/** Accès paramètres entreprise (équipe, heures & majoration) — sans organisation */
export const ROLES_COMPANY_SETTINGS_ACCESS = [ROLE_BIG_COMPANY_ADMIN, 215, 210];
